import { render, staticRenderFns } from "./identity-confirm-page.vue?vue&type=template&id=1a49a4ea&scoped=true"
import script from "./identity-confirm-page.vue?vue&type=script&lang=js"
export * from "./identity-confirm-page.vue?vue&type=script&lang=js"
import style0 from "./identity-confirm-page.vue?vue&type=style&index=0&id=1a49a4ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a49a4ea",
  null
  
)

export default component.exports